import { StoreState } from '@/redux/types';
import { getDesign } from './getDesign';

export const selectDesign = (designId: string) => (state: StoreState) => getDesign(state, designId);
